import { render } from "./SiteBlock.vue?vue&type=template&id=8f780d7a&ts=true"
import script from "./SiteBlock.vue?vue&type=script&lang=ts"
export * from "./SiteBlock.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./SiteBlock.vue?vue&type=style&index=0&id=8f780d7a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__